module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/H2-8a70bc6ea9d6e186c9fbcf2d4ac2ab19.svg";